<div class="offcanvas-header">
	<div class="heading">
		<h3 class="offcanvas-title">Inventory Items</h3>
		<div class="subheading">{{ inventoryLocation.name }}</div>
	</div>
	<button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<hr class="mx-3" />
<div class="offcanvas-body">
	<div class="body">
		<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"></app-loading-state>
		<ng-template #loadedContent>
			<div class="inventory-item-location-container">
				<div class="section">
					<h6>Stock at location</h6>

					<ng-container *ngIf="inventoryItemLocations.length > 0; else noLocations">
						<div class="table-container">
							<div class="table-headings">
								<div class="column-name long">Item</div>
								<div class="column-name long">Quantity</div>
							</div>

							<ng-container *ngFor="let itemLocation of inventoryItemLocations">
								<div class="table-row">
									<div class="inner-row long">
										{{ itemLocation.inventoryItemData?.name | nullDefault: '-' }}
									</div>
									<div class="inner-row long">
										{{ itemLocation.quantity | nullDefault: '-' }}
									</div>
								</div>
							</ng-container>
						</div>
					</ng-container>

					<ng-template #noLocations>
						<div class="text-muted fst-italic">No stock at this location yet.</div>
					</ng-template>
				</div>
			</div>
		</ng-template>
	</div>
</div>
